// extracted by mini-css-extract-plugin
export default {"infoCard":"Card_infoCard__LKw7G","icons":"Card_icons__1Fnzj","heading":"Card_heading__HLWpT"};